import * as React from "react";

import { Dropdown as AntDropdown, Avatar } from "antd";
import { ItemType } from "antd/es/menu/interface";

import { AvatarWrapper, Nav } from "./styles";

const AvatarNavItem = ({
  isVisible,
  userName,
  userRole,
  items,
}: {
  isVisible: boolean;
  userName: string;
  userRole: string;
  items: ItemType[];
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <AntDropdown trigger={["click"]} menu={{ items }}>
        <AvatarWrapper>
          <Avatar size="large">{userName[0]}</Avatar>
          <div>
            <h3>{userName}</h3>
            <p>{userRole}</p>
          </div>
        </AvatarWrapper>
      </AntDropdown>
    </Nav.Item>
  );
};

export default AvatarNavItem;
